<template>
  <div id="app">
    <CalcTool />
  </div>
</template>

<script>
import CalcTool from "@/views/CalcTool";
//eslint-disable-next-line
import fancyInput from "@/assets/scss/_fonts.scss";

export default {
  components: {
    CalcTool
  }
};
</script>

<style lang="scss">
// @import url(https://www.regent.ch/typo3temp/assets/compressed/merged-dc728511feac96a4748f898bee456766.css?1551880333);

#app {
  font-family: "geomanist", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 2em;
}
</style>
